<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-demo__customers}">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          
          <el-form-item >
            <el-input v-model="dataForm.telEncrypt" placeholder="手机加密码" clearable></el-input>
          </el-form-item>

         
            <el-form-item >
            <el-input v-model="dataForm.mobile" placeholder="手机号码" clearable></el-input>
          </el-form-item>
        <el-form-item >
            <el-select v-model="dataForm.city" filterable clearable placeholder="请选择城市">
              <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
      <el-form-item >
        <el-form-item  style="width:280px" >
              <el-select style="width:135%" v-model="dataForm.companyName" filterable clearable placeholder="公司名称">
                  <el-option
                          
                          v-for="item in companyList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
    
      </el-form-item>
          <el-form-item>
            <el-button @click="getDataList()">{{ $t('query') }}</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button v-if="$hasPermission('sys:customers:export')" type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button v-if="$hasPermission('sys:customers:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button v-if="$hasPermission('sys:customers:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
          </el-form-item> -->
        
        </el-form>
        <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;" max-height="550">
          <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
          <el-table-column prop="id" label="ID" header-align="center" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="city" label="城市" header-align="center" align="center"></el-table-column>
          <el-table-column prop="company" label="公司ID" header-align="center" align="center"></el-table-column>
          <el-table-column prop="mobile" label="手机号" header-align="center" align="center" width="110"></el-table-column>
          <el-table-column prop="companyName" label="公司名称" header-align="center" align="center" width="130"></el-table-column>
          <el-table-column prop="status" label="状态" header-align="center" align="center" width="150" :show-overflow-tooltip="true">
          	<template slot-scope="scope">
	            <el-tag v-if="scope.row.status === 0" type="danger" size="small">停用</el-tag>
	            <el-tag v-if="scope.row.status === 1" size="small">正常</el-tag>
        	</template>
          </el-table-column>
          <el-table-column prop="createUser" label="创建人" header-align="center" align="center"></el-table-column>
          <el-table-column prop="encrypt" label="加密方式" header-align="center" align="center" width="150" :show-overflow-tooltip="true">
             <!-- <template  slot-scope="scope">

             </template> -->
           
          </el-table-column>
          <el-table-column prop="telEncrypt" label="手机加密码" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="updateUser" label="更新人" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
          
          <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            
            <el-button v-if="$hasPermission('sys:operations:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:operations:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
         
  
          
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <RepeatmobileOrUpdate v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></RepeatmobileOrUpdate>
      </div>
  
      <el-dialog
        title="返回信息"
        :visible.sync="dialogVisible"
        width="30%"
       >
        <span>{{returnedMessagesVal}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
  import RepeatmobileOrUpdate from './repeatmobile-add-or-update'
  import { getOperations,getCompanies } from '../../../api/list'


  export default {
    mixins: [mixinViewModule],
    
    data () {
      return {
        dialogVisible:false,
        returnedMessagesVal:'',
        
        mixinViewModuleOptions: {
          getDataListURL: '/zy/repeatmobile',
          getDataListIsPage: true,
          exportURL: '/zy/repeatmobile/export',
          deleteURL: '/zy/repeatmobile',
          deleteIsBatch: true
        },
        citys:[],
        companyList:[],
        loanTypes:[],
        dataForm: {
          id: '',
          isFixed:'',
        },
        operationsList:[],
        isFixedList:[
            {
              value: 0,
              label:'非直投'
            },
            {
              value: 1,
              label:'直投'
            }
          ],
        pages:[],
        companys:[],
        channels:[],
        callTypes:[
          // {
          //     'label':'未回访',
          //     'value':0,
          // },
          // {
          //     'label':'有效表单',
          //     'value':1,
          // }
        ],
        isPushs:[
          {
              'label':'未推送',
              'value':0,
          },
          {
              'label':'已推送',
              'value':1,
          }
        ],
      }
    },
    components: {
        RepeatmobileOrUpdate
    },
  async  created () {
      
      if (this.mixinViewModuleOptions.createdIsNeed) {
        this.query()
      
        
    
      
        this.getCityOptions();

      
        this.operationsList = []
        let res = await getOperations()
        let res1 = await getCompanies()
        if(res1.data.code == 0){
        this.companyList = res1.data.data.list.map(item => ({value:item.id,label:item.name,}))
       
        }else{
          this.$mesage.error(res.data.msg)
        }
       if(res.data.code == 0){
        this.operationsList = res.data.data.list.map(item => ({value:item.name,label:item.name}))
       }else{
        this.$message.error(res.data.msg)
       }
      
      }
    },
    methods: {
      handleReturnMsg(returnMsg){
        this.dialogVisible = true;
        this.$nextTick(() =>{
          this.returnedMessagesVal = returnMsg
        })
      },
        //初始化下拉框中的选项
        async getCityOptions() {
        this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.citys=[];
          if (res.data!=null){
            res.data.forEach(element => {
              this.citys.push({label:element.dictLabel,value:element.dictValue})
            })
          }
        }).catch(() => {})
      },
   
    
         
      
      againPush(id){
          this.$http.get(`/sys/customers/againPush/${id}`,id).then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.query();
         }).catch(() => {})
         
      }
    }
  }
  </script>


<style scoped>

</style>
  